import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shippingInfo: null,
  shippingMethod: 'null', // ← ahora sí tiene valor por defecto
  paymentMethod: 'standard',
  orderSummary: {
    subtotal: 0,
    shipping: 0, // si standard cuesta 10
    taxes: 0,
    total: 10, // subtotal + shipping + taxes
  },
  customerNote: '',
  checkoutStep: 'shipping',
  loading: false,
  error: null,
  taxesEnabled: null,
};


const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    saveShippingInfo: (state, action) => {
      state.shippingInfo = action.payload;
    },
    saveShippingMethod: (state, action) => {
      const method = action.payload;
      state.shippingMethod = method;

      // Definir costos de envío en COP
      const shippingCosts = {
        free: 0,
        standard: 35000,
        premium: 50000,
      };

      const shipping = shippingCosts[method] ?? 0;
      const subtotal = state.orderSummary.subtotal;
      const taxes = state.taxesEnabled ? subtotal * 0.15 : 0;
      const total = subtotal + shipping + taxes;

      state.orderSummary = {
        ...state.orderSummary,
        shipping,
        taxes,
        total,
      };
    },

    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    updateOrderSummary: (state, action) => {
      const subtotal = typeof action.payload === 'number' ? action.payload : action.payload.subtotal;
      const skipTaxes = typeof action.payload === 'object' && action.payload.skipTaxes;

      // Si skipTaxes es true, los impuestos deben ser 0
      const taxes = skipTaxes ? 0 : state.taxesEnabled ? subtotal * 0.15 : 0;

      let shipping = 0;
      if (state.shippingMethod === 'premium') {
        shipping = 50000;
      } else if (state.shippingMethod === 'standard') {
        shipping = 35000;
      } else if (state.shippingMethod === 'free') {
        shipping = 0;
      }


      const total = subtotal + shipping + taxes;

      state.orderSummary = {
        ...state.orderSummary,
        subtotal,
        shipping,
        taxes,
        total,
      };
    },
    toggleTaxes: (state, action) => {
      if (action.payload === false) {
        // Si "No, sin factura" es seleccionado, los impuestos se ponen a 0
        state.taxesEnabled = false;
        const { subtotal, shipping } = state.orderSummary;
        const taxes = 0;
        const total = subtotal + shipping + taxes;

        state.orderSummary = {
          ...state.orderSummary,
          taxes,
          total,
        };
      } else {
        // Si "Sí, con factura" es seleccionado, se calculan los impuestos
        state.taxesEnabled = true;
        const { subtotal, shipping } = state.orderSummary;
        const taxes = subtotal * 0.15;
        const total = subtotal + shipping + taxes;

        state.orderSummary = {
          ...state.orderSummary,
          taxes,
          total,
        };
      }
    },
    setCustomerNote: (state, action) => {
      state.customerNote = action.payload;
    },
    setCheckoutStep: (state, action) => {
      state.checkoutStep = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearCheckout: () => {
      return { ...initialState };
    },
  },
});

export const {
  saveShippingInfo,
  saveShippingMethod,
  savePaymentMethod,
  updateOrderSummary,
  setCustomerNote,
  setCheckoutStep,
  setLoading,
  setError,
  clearCheckout,
  toggleTaxes,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
